<template>
	<div class="hm-modal">
		<a-modal
			:visible="cVisible"
			:confirm-loading="confirmLoading"
			:width="cWidth"
			:cancel-text="cancelText"
			:closable="closable"
			@ok="handleOk"
			@cancel="handleCancel"
			@afterClose="afterClose"
		>
			<template v-slot:title>
				<slot name="title">
					{{ title }}
				</slot>
			</template>

			<slot></slot>

			<template v-slot:footer>
				<slot name="footer">
					<a-button @click="handleCancel">{{ cancelText }}</a-button>
					<a-button :type="okType" @click="handleOk">{{ okText }}</a-button>
				</slot>
			</template>
		</a-modal>
	</div>
</template>

<script>
export default {
	name: "HmModal",
	components: {},
	props: {
		/**
		 * 对话框标题
		 */
		title: {
			type: String,
			default: "对话框",
		},
		/**
		 * 是否可见
		 */
		visible: {
			type: Boolean,
			default: true,
		},
		/**
		 * 显示loading
		 */
		confirmLoading: {
			type: Boolean,
			default: true,
    },
    /**
     * 显示关闭按钮
     */
		closable: {
			type: Boolean,
			default: false,
		},
		/**
		 * 确认按钮文字
		 */
		okText: {
			type: String,
			default: "确定",
		},
		/**
		 * 确认按钮类型
		 */
		okType: {
			type: String,
			default: "primary",
		},
		/**
		 * 取消按钮文字
		 */
		cancelText: {
			type: String,
			default: "取消",
		}
	},
	data() {
		return {
      cWidth: "520px",
      cVisible: true
		};
	},
	watch: {
		width(value) {
			this.cWidth = this.getCssUnit(value);
		},
	},
	computed: {},
	mounted() {
    this.cWidth = this.getCssUnit(this.width);
    this.cVisible = this.visible;
	},
	methods: {
		getCssUnit(value) {
			if (isNaN(Number(value))) {
				return value;
			}
			return `${value}px`;
		},
		handleOk(e) {
			console.log(`ok: `, e);
      this.$emit("ok", e);
      this.cVisible = false;
		},
		handleCancel(e) {
			console.log(`cancel: `, e);
      this.$emit("cancel", e);
      this.cVisible = false;
		},
		afterClose(e) {
			console.log(`afterClose: `, e);
			this.$emit("after-close", e);
		},
	},
};
</script>

<style scoped>
.hm-modal {
  min-width: 100px;
  width: 100%;
  min-height: 100px;
  height: 100%;
}

.modal-slot {
	min-height: 200px;
}
</style>